// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-button-close__xs[data-v-5f8071e1]{width:1.125rem!important;height:1.125rem!important}.e-button-close__xs .v-btn__content .v-icon[data-v-5f8071e1]{font-size:.8rem;height:1.25rem}", ""]);
// Exports
module.exports = exports;
